export default __webpack_public_path__ + "static/media/todo1.4ab2c556.png";